import React, { useCallback, useState } from "react";
import { Button } from "@folio/stripes/components";
import { PeriodicalCheckSettingsDialog } from "./PeriodicalCheckSettingsDialog";
import css from "./PeriodicalCheckSettingsLink.module.css";
export var PeriodicalCheckSettingsLink = function (_a) {
    var settings = _a.settings, label = _a.label, proposedAnchor = _a.proposedAnchor, _b = _a.buttonStyle, buttonStyle = _b === void 0 ? "link" : _b;
    var _c = useState(false), settingsOpen = _c[0], setSettingsOpen = _c[1];
    var handleOpen = useCallback(function () { return setSettingsOpen(true); }, []);
    var handleClose = useCallback(function () { return setSettingsOpen(false); }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { buttonStyle: buttonStyle, buttonClass: buttonStyle === "link" ? css.link : undefined, marginBottom0: true, onClick: handleOpen }, label),
        React.createElement(PeriodicalCheckSettingsDialog, { open: settingsOpen, settings: settings, proposedAnchor: proposedAnchor, onClose: handleClose })));
};
